import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
var css = {
  "iconButton": "rui-3a8k1",
  "animation": "rui-ByR9G"
};
import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import classNames from 'classnames';
var NewIconButton = function NewIconButton(_ref) {
  var icon = _ref.icon,
    name = _ref.name,
    dataAutId = _ref['data-aut-id'],
    onClick = _ref.onClick,
    href = _ref.href,
    htmlType = _ref.htmlType,
    rel = _ref.rel,
    active = _ref.active,
    color = _ref.color,
    animation = _ref.animation,
    direction = _ref.direction,
    size = _ref.size,
    className = _ref.className,
    overrideClassName = _ref.overrideClassName,
    theme = _ref.theme;
  var Tag;
  var props;
  if (href) {
    Tag = Link;
    props = {
      to: href,
      rel: rel
    };
  } else {
    Tag = 'button';
    props = {
      type: htmlType
    };
  }
  return /*#__PURE__*/React.createElement(Tag, Object.assign({}, props, {
    className: classNames(css.iconButton, _defineProperty({}, css.animation, animation), className),
    onClick: onClick,
    onKeyPress: onClick,
    role: "button",
    tabIndex: "0",
    "data-aut-id": dataAutId,
    title: name
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    color: color || (active ? 'accentDark' : 'blackText'),
    size: size,
    direction: direction,
    theme: theme,
    overrideClassName: overrideClassName
  }));
};
NewIconButton.defaultProps = {
  'data-aut-id': '',
  name: '',
  className: '',
  overrideClassName: '',
  onClick: function onClick() {},
  href: '',
  htmlType: 'button',
  rel: '',
  active: false,
  animation: true,
  color: '',
  direction: 'ltr',
  size: 24
};
export default NewIconButton;